import type { FetchResult } from '@apollo/client';
import type { PlaceOrderMutation } from '../graphqlDocument/order/placeOrder.generated';

export type ValidityStatus = {
  encryptedCardNumber: { isValid: boolean };
  encryptedExpiryDate: { isValid: boolean };
  encryptedSecurityCode: { isValid: boolean };
  holderName: null;
};

export type CheckedStatus = {
  billingAddress: boolean;
  encryptedCardNumber: boolean;
  encryptedExpiryMonth: boolean;
  encryptedExpiryYear: boolean;
  encryptedSecurityCode: boolean;
  holderName: boolean;
  socialSecurityNumber: boolean;
  taxNumber: boolean;
};

export type RefusalReasonType = {
  [key: string]: string;
};

export type PlaceOrderMutationFn = () => Promise<FetchResult<
  PlaceOrderMutation,
  Record<string, unknown>,
  Record<string, unknown>
> | null>;

export const enum PaymentResultCode {
  AUTHORISED = 'Authorised',
  RECEIVED = 'Received',
  REFUSED = 'Refused',
}
